"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crmValidateMapping = exports.crmUpdate = exports.crmTestBulk = exports.crmSuccess = exports.crmSaveBulk = exports.crmReset = exports.crmPause = exports.crmList = exports.crmImportMapping = exports.crmImportData = exports.crmGet = exports.crmError = exports.crmDownloadMappingCC = exports.crmDownloadErrorMapping = exports.crmDisconnect = exports.crmDelete = void 0;
var _crm = require("./crm.constant");
// @flow

// common success
var crmSuccess = function crmSuccess(actionType, data) {
  return {
    type: _crm.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.crmSuccess = crmSuccess;
var crmError = function crmError(actionType, error) {
  return {
    type: _crm.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.crmError = crmError;
var crmList = function crmList(data) {
  return {
    type: _crm.actionTypes.LIST,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get of data.
 */
exports.crmList = crmList;
var crmGet = function crmGet(data) {
  return {
    type: _crm.actionTypes.GET,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.crmGet = crmGet;
var crmUpdate = function crmUpdate(data) {
  return {
    type: _crm.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.crmUpdate = crmUpdate;
var crmDelete = function crmDelete(data) {
  return {
    type: _crm.actionTypes.DELETE,
    payload: data
  };
};

/**
 * disconnect
 * @param payload
 * @returns api response
 * @description this function used to disconnect data.
 */
exports.crmDelete = crmDelete;
var crmDisconnect = function crmDisconnect(data) {
  return {
    type: _crm.actionTypes.DISCONNECT,
    payload: data
  };
};

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
exports.crmDisconnect = crmDisconnect;
var crmPause = function crmPause(data) {
  return {
    type: _crm.actionTypes.PAUSE,
    payload: data
  };
};

/**
 * import data
 * @param payload
 * @returns api response
 * @description this function used to import data.
 */
exports.crmPause = crmPause;
var crmImportData = function crmImportData(data) {
  return {
    type: _crm.actionTypes.IMPORT_DATA,
    payload: data
  };
};

/**
 * validate mapping
 * @param payload
 * @returns api response
 * @description this function used to validate mapping.
 */
exports.crmImportData = crmImportData;
var crmValidateMapping = function crmValidateMapping(data) {
  return {
    type: _crm.actionTypes.VALIDATE_MAPPING,
    payload: data
  };
};

/**
 * import mapping
 * @param payload
 * @returns api response
 * @description this function used to import mapping.
 */
exports.crmValidateMapping = crmValidateMapping;
var crmImportMapping = function crmImportMapping(data) {
  return {
    type: _crm.actionTypes.IMPORT_MAPPING,
    payload: data
  };
};

/**
 * download mapping
 * @param payload
 * @returns api response
 * @description this function used to download mapping.
 */
exports.crmImportMapping = crmImportMapping;
var crmDownloadErrorMapping = function crmDownloadErrorMapping(data) {
  return {
    type: _crm.actionTypes.DOWNLOAD_MAPPING,
    payload: data
  };
};

/**
 * download mapping
 * @param payload
 * @returns api response
 * @description this function used to download mapping.
 */
exports.crmDownloadErrorMapping = crmDownloadErrorMapping;
var crmDownloadMappingCC = function crmDownloadMappingCC(data) {
  return {
    type: _crm.actionTypes.DOWNLOAD_MAPPING_CUSTOM_COLUMN,
    payload: data
  };
};

/**
 * save bulk
 * @param payload
 * @returns api response
 * @description this function used to download mapping.
 */
exports.crmDownloadMappingCC = crmDownloadMappingCC;
var crmSaveBulk = function crmSaveBulk(data) {
  return {
    type: _crm.actionTypes.SAVE_BULK,
    payload: data
  };
};

/**
 * test bulk
 * @param payload
 * @returns api response
 * @description this function used to download mapping.
 */
exports.crmSaveBulk = crmSaveBulk;
var crmTestBulk = function crmTestBulk(data) {
  return {
    type: _crm.actionTypes.TEST_BULK,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.crmTestBulk = crmTestBulk;
var crmReset = function crmReset() {
  return {
    type: _crm.actionTypes.RESET
  };
};
exports.crmReset = crmReset;